var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWoTm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 20,
    viewBox: "0 0 124 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3605 0.031099V10.1711C20.3605 15.5832 15.7858 20 10.1802 20C4.57466 20 0 15.5832 0 10.2022V0.031099H3.51154V10.2022C3.51154 13.7481 6.50762 16.6407 10.1802 16.6407C13.8529 16.6407 16.8489 13.7481 16.8489 10.2022V0.031099H20.3605ZM51.5883 19.9684V0H48.0559V19.9684H51.5883ZM65.0373 0C59.3984 0 54.829 4.49367 54.829 10C54.829 15.5063 59.4308 20 65.0697 20H71.9724V16.5506H65.0697C61.3753 16.5506 58.3614 13.6076 58.3614 10.0316C58.3614 6.42405 61.3753 3.48101 65.0697 3.48101H71.94V0.0316403H65.0373V0ZM79.0371 0V19.9684H75.5048V0H79.0371ZM119.578 0V1.86709C119.578 5.47468 116.597 8.41772 112.903 8.41772C109.208 8.41772 106.227 5.47468 106.227 1.86709V0H102.694V1.86709C102.694 6.77215 106.356 10.8861 111.153 11.7089V20H114.685V11.7089C119.481 10.8861 123.143 6.8038 123.143 1.86709V0H119.578ZM82.3751 3.44937V0H99.7129V3.44937H92.8102V19.9684H89.2778V3.44937H82.3751ZM27.7043 19.9689V9.79782C27.7043 6.25194 30.6507 3.35925 34.2625 3.35925C37.8743 3.35925 40.8208 6.25194 40.8208 9.79782V19.9689H44.2742V9.79782C44.2742 4.38569 39.7753 0 34.2625 0C28.7498 0 24.2509 4.4168 24.2509 9.82893V20H27.7043V19.9689Z",
    fill: "#003B6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWoTm);
export default __webpack_public_path__ + "static/media/logo-wo-tm.26c4702a9522656f8783f26cce544d77.svg";
export { ForwardRef as ReactComponent };